<!-- The print view fills the days of a report one chart at a time, so an instance can exist before its
     day is handed over (empty placeholder). Such an instance must not render anything: there is no day
     to read the driver/vehicle header from, and an empty chart box would be printed as a blank block. -->
<div *ngIf="currentLang && hasChart" [ngClass]="isPrinting ? 'dailyChartOuter print' : 'dailyChartOuter'">
    <div class="dailyChartOuterCont" *appLoadingSpinner="chartLoading">
        <div class="dailyChartCalendar" *ngIf="isPrinting && isMultiEntityPrint && typeOfChart === tabOptions.DRIVER">
            {{ '' | nameChart:dailyChartInput?.driverFirstName:dailyChartInput?.driverLastName:('Report.DailyChart.nameFormat' | instantTranslate: dailyChartService.chartLanguage | async) }}
        </div>
        <div class="dailyChartCalendar" *ngIf="isPrinting && isMultiEntityPrint && typeOfChart === tabOptions.VEHICLE">
            {{ dailyChartInput?.vehicleRegistrationNumber }} / {{ dailyChartInput?.vehicleIdentificationNumber }}
        </div>

        <!-- The chart draws at the width of its host: the print view caps that host at the printable
             page width (see dailychart.component.css). Forcing a wider minimum here made every printed
             chart wider than the paper and put a horizontal scrollbar under it. -->
        <tacho-activity-chart *ngIf="chartData"
            [data]="chartData"
            [timezone]="timezone"
            [locale]="currentLang || 'en-GB'"
            [visibility]="chartVisibility"
            mode="stacked"
            [dataSource]="typeOfChart === tabOptions.DRIVER ? 'driver' : 'vehicle'"
            theme="light"
            barHeightMode="specific"
            [showDayMeta]="true"
            [showRulers]="true"
            [laneHeight]="isPrinting ? 55 : 70"
            [navigator]="false"
            [toolbar]="false"
            [legend]="true"
            [interactive]="!isPrinting"
            [minWidth]="320">
        </tacho-activity-chart>
    </div>
</div>
